<template>
  <v-dialog v-model="dialogTmcShow" scrollable max-width="1200px" >
    <v-card>
      <v-toolbar dense flat dark>
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{tmcName}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="closeDialog">Закрити</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
       

        <v-row>
            <v-container>
              <v-row>
                <v-alert v-show="errorAlertShow" dense outlined type="error"><strong>Критична помилка! </strong>( {{errorMessage}} )</v-alert>
                <v-progress-linear v-show="progresLineShow" indeterminate color="red"></v-progress-linear>
              </v-row>
              
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                  v-model="tmcName"
                  label="Назва ТМЦ:"
                  type="text"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                  v-model="tmcArticle"
                  label="Артикул:"
                  type="text"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-card>
                <v-tabs >
                  <v-tab>Одиниці виміру</v-tab>
                  <v-tab>Додаткові прараметри</v-tab>
                  <v-tab>Маркування</v-tab>
                  <v-tab>Специфікація</v-tab>
                  <v-tab>Зображення</v-tab>
                  <v-tab>Вартість</v-tab>
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        Одиниці виміру
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        Додаткові прараметри
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        Маркування
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        Специфікація
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        Зображення
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        <v-col cols="12" sm="12" md="6">
                          <v-text-field
                            v-model="tmcCost"
                            label="Вартість"
                            append-outer-icon="mdi-check"
                            @click:append-outer="sendTmcCost"
                            @keydown.enter="handleEnterKey"
                          >
                          </v-text-field>
                        </v-col>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-card>
            </v-container>
        </v-row>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['value', 'tmc'],
  data() {
    return {
      errorMessage: '',
      errorAlertShow: false,
      progresLineShow: false,
      dialogTmcShow: false,
      tmcName: '',
      tmcArticle: '',
      tmcCost: 0.00,
    };
  },
  watch: {
    value(newValue) {
      this.dialogTmcShow = newValue;
    },
    dialogTmcShow() {
      this.$emit('input', this.dialogTmcShow);
    },
    tmc(tmc){
      this.getTmcInfo(tmc)
    }
  },
  methods: {
    closeDialog() {
      this.dialogTmcShow = false;
      this.tmcName = '';
      this.tmcArticle = '';
      this.tmcCost = 0.00;
      this.$emit('input', this.dialogTmcShow);
    },
    getTmcInfo(tmc) {
      this.progresLineShow = true;
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          act: '28',
          ww: '2',
          pp: localStorage.pp,
          pn: localStorage.pn,
          tmc: tmc,
        })
      };
      fetch(this.$store.getters.apiUrl, requestOptions)
      .then((data) => {
        if (!data.ok) {
          const error = (data && data.message) || data.status
          return Promise.reject(error)
        }
        return data
      })
      .then((data) => data.json())
      .then((data) => {
        if (data.isauth == true) {
          this.progresLineShow = false
          this.tmcArticle= data.tmcinfo[0].article
          this.tmcName = data.tmcinfo[0].name
          this.tmcCost = data.tmcinfo[0].cost
        }
        if (data.isauth == false) {
          this.$router.push('/login').catch(()=>{})
        }
      })
      .catch(error => {
        this.errorMessage = error
        this.progresLineShow = false
        this.errorAlertShow = true
      });
    },
    sendTmcCost(){
      this.progresLineShow = true;
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          act: '28',
          ww: '3',
          pp: localStorage.pp,
          pn: localStorage.pn,
          tmc: this.tmc,
          cost: this.tmcCost,
        })
      };
      fetch(this.$store.getters.apiUrl, requestOptions)
      .then((data) => {
        if (!data.ok) {
          const error = (data && data.message) || data.status
          return Promise.reject(error)
        }
        return data
      })
      .then((data) => data.json())
      .then((data) => {
        if (data.isauth == true) {
          this.progresLineShow = false
          //this.tmcArticle= data.tmcinfo[0].article
          //this.tmcName = data.tmcinfo[0].name
        }
        if (data.isauth == false) {
          this.$router.push('/login').catch(()=>{})
        }
      })
      .catch(error => {
        this.errorMessage = error
        this.progresLineShow = false
        this.errorAlertShow = true
      });
    },
    handleEnterKey(event) {
      if (event.key === 'Enter') {
        this.sendTmcCost();
      }
    },
    
  },
  computed: {

  },
  created: function () {

  },
};
</script>